import Header from '../Layout/Header';

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './css/tata.css';
import { dataUser } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import Sidebar from "../../Component/Layout/Sidebar";
import CustomHeader from "../../Component/Layout/Header";
import { Layout } from "antd";
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';

function TataTeleService({ }) {
    var UserObj = JSON.parse(dataUser());
    const name = UserObj ? UserObj.fname : '';
    const lname = UserObj ? UserObj.lname : '';
    const companyName = UserObj ? UserObj.company_name : '';
    const email = UserObj ? UserObj.email : '';
    const location = UserObj ? UserObj.address : '';
    const [loader, setLoader] = useState(false)

    const [showTataTele, setShowTataTele] = useState(false);

    const exploreNowMixPanel = () => {
        if (UserObj) {
            mixpanel.track('Network Solutions', {
                PageName: 'Tata TeleService',
                UserEmail: UserObj.email,
                UserName: UserObj.fname + ' ' + UserObj.lname,
                UserId: UserObj.rec_id,
                CompanyId: UserObj.company_id,
                CompanyName: UserObj.company_name,
                Type: 'Tata TeleService Banner',
            });
        }
    }

    useEffect(() => {
        setLoader(true)
    }, [])



// Sidebar Toggle
const [collapsed, setCollapsed] = useState(true); // Sidebar collapsed state
  const toggleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };

    return (
    <>
        <Layout>
        
        <Sidebar collapsed={collapsed}/>
        
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        
        <Layout className={collapsed ? 'no_pad_page PageLayout CollapsedPageLayout' : 'no_pad_page PageLayout'}>
            <div class="PageContent">
                {loader ? (
                    <div className="Tata_LandingPage">
                        <div className="wrapper">
                            <div className="Tata_img_container">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1920 1007">
                                    <image width="1920" height="1007" xlinkHref="https://d2jovvsod2x1gg.cloudfront.net/csp-files/Tata-Landing-Design-p1.jpg"></image>
                                    <a role='button' 
                                        onClick={() => {
                                            setShowTataTele(true);
                                            exploreNowMixPanel();
                                        }}
                                    >
                                        <rect x="802" y="755" fill="#fff" opacity="0" width="315" height="83"></rect>
                                    </a>
                                </svg>
                            </div>
                            <div className="Tata_img_container">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1920 1032">
                                    <image width="1920" height="1032" xlinkHref="https://d2jovvsod2x1gg.cloudfront.net/csp-files/Tata-Landing-Design-p2.jpg"></image>
                                    <a role='button' onClick={() => setShowTataTele(true)}>
                                        <rect x="872" y="909" fill="#fff" opacity="0" width="163" height="50"></rect>
                                    </a>
                                    <a role='button' onClick={() => setShowTataTele(true)}>
                                        <rect x="1166" y="909" fill="#fff" opacity="0" width="160" height="50"></rect>
                                    </a>
                                    <a role='button' onClick={() => setShowTataTele(true)}>
                                        <rect x="1460" y="909" fill="#fff" opacity="0" width="164" height="50"></rect>
                                    </a>
                                </svg>
                            </div>
                            <div className="Tata_img_container">
                                <img src='https://d2jovvsod2x1gg.cloudfront.net/csp-files/Tata-Landing-Design-p3.jpg' alt='' />
                            </div>
                            <div className="Tata_img_container">
                                <img src='https://d2jovvsod2x1gg.cloudfront.net/csp-files/Tata-Landing-Design-p4.jpg' alt='' />
                            </div>
                        </div>
                    </div>
                ) : <div className='d-flex align-items-center justify-content-center'>
                    <img
                        className=""
                        src="img/meal-plan/loaderMealPlan.gif" height={"100px"} width={"100px"}
                    />

                </div>}

            </div>
            
            
            <SwOffCanvas
                show={showTataTele}
                onClose={() => setShowTataTele(false)}
                title="Network Solutions"
                placement="end"
                size="md"
                className='LandingIframeDrawer'
            >
                <iframe
                    className="Addon-iframe-placeholder"
                    id="iframe1"
                    width="100%"
                    frameborder="0"
                    src={`https://form.typeform.com/to/Mcbyo01e#company_name=${companyName}&email=${email}&spoc_name=${name + ' ' + lname}&location=${location}`}
                />
            </SwOffCanvas>

            {/* Form Modal */}
            <div
                id="ConnectSmart"
                className="AddOnModalPopup custome  right modal fade"
            >
                <div className="modal-dialog custome ">
                    <div className="modal-content custome ">
                        <div className="formTitle" style={{ background: "#291749" }}>
                            {/* Sales Lead Banner */} Network Solutions
                            <button
                                type="button"
                                className="relateDox close"
                                data-dismiss="modal"
                            >
                                x
                            </button>
                        </div>
                        <div className="modal-body custome ">
                            <iframe
                                className="Addon-iframe-placeholder"
                                id="iframe1"
                                width="100%"
                                frameborder="0"
                                src={`https://form.typeform.com/to/Mcbyo01e#company_name=${companyName}&email=${email}&spoc_name=${name + ' ' + lname}&location=${location}`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </Layout>
        
        </>
    );
}
export default connect(
)(TataTeleService);